import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import riskAnalysisQuestionnaireDataAccess from "src/dataAccess/riskAnalysisQuestionnaires/riskAnalysisQuestionnaireDataAccess";
export const getCompletedRAListAsync = createAction<any>(
  "[RiskAnalysis] Get Completed RA List Success"
);
export const getCompletedRAListA = createAsyncThunk<any, IListType>(
  "[RiskAnalysis]  Get Completed RA List ",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));
    const result = await riskAnalysisQuestionnaireDataAccess
      .getCompletedRAList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getCompletedRAListAsync(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  }
);
export const getRiskAnalysisListSuccess = createAction<any>(
  "[RiskAnalysis] Get Risk Analysis List Success"
);
export const loadingList = createAction<boolean>("[RiskAnalysis] Loading list");
export const setProcedureId = createAction<any>(
  "[RiskAnalysis] Set ProcedureId"
);
export const getRiskAnalysisListAsync = createAsyncThunk<any, IListType>(
  "[RiskAnalysis] Get Risk Analysis List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));

    const result = await riskAnalysisQuestionnaireDataAccess
      .getList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getRiskAnalysisListSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  }
);

export const updateHasAnyPRAChange = createAction<boolean>(
  "[RiskAnalysisProcess] Update Has Any Change"
);
